import { AppLayout } from "../shared";
import ConnectClub from "../MasterOrg/ConnectClub";

const MasterOrgConnect_layout = ({ props, setIsLoaded }) => (
  <AppLayout props={props}>
    <ConnectClub props={props} setIsLoaded={setIsLoaded} />
  </AppLayout>
);

export default MasterOrgConnect_layout;
